define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        EffectModel  = require("shared/ui/experience/action/effects/EffectModel"),
        template     = require("ui/experience/action/properties/RotateEffectPropertiesView.tpl");

    return ImprovedView.extend({

        template: template,

        bindings: {
            ".rotation": "rotation"
        },

        attentionBindings: {
            "input[name='attentionMode']": "attentionMode",
            ".rotation-direction-selection": "rotationDirection"
        },

        onRender: function() {
            if (this.model.get("triggerType") === EffectModel.TRIGGER_TYPE_ATTENTION) {
                this.stickit(this.model, this.attentionBindings);
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/properties/RotateEffectPropertiesView.js